<template>
  <div class="chat-item-default my-1" :class="{me: isMine}">
    <small v-if="isMine" class="p-2 text-muted">{{ value.created_at | moment("from", "now") }}</small>
    <span v-if="otherUser" class="px-2 py-1">{{callMessageText}}</span>
    <small v-if="!isMine" class="p-2 text-muted">{{ value.created_at | moment("from", "now") }}</small>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Fetch from '@/mixins/Fetch'
export default {
  mixins: [Fetch],
  props: {
    value: {
      type: Object,
      required: true
    },
    author: {
      type: Object,
      required: true
    },
    isMine: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      otherUser: null
    }
  },
  mounted () {
    const otherUserId = this.authUser.id === this.value.message.caller_id ? this.value.message.callee_id : this.value.message.caller_id
    this.fetchUser(otherUserId, (user) => {
      this.otherUser = user
    })
  },
  computed: {
    ...mapGetters({
      authUser: 'auth/user'
    }),
    callMessageText () {
      if (this.authUser && this.authUser.id === this.value.message.callee_id) {
        switch (this.value.message.status) {
          case 'ongoing_finished':
            return this.otherUser.name + '-მ(ა) ' + this.$t('called_you')
          case 'pending_busy':
          case 'pending_unreachable':
          case 'pending_disconnected':
          case 'pending_failed':
          case 'ringing_declined':
          case 'ringing_finished':
          case 'ringing_missed':
          case 'ringing_failed':
          case 'ringing_disconnected':
          case 'ongoing_disconnected':
          case 'ongoing_failed':
            return this.$t('you_missed_call') + ' ' + this.otherUser.name + '-სგან'

          default:
            return this.$t('call') + ' ' + this.otherUser.name + '-სგან'
        }
      }

      switch (this.value.message.status) {
        case 'ongoing_finished':
          return this.$t('you_called') + ' ' + this.otherUser.name + '-ს'
        case 'pending_busy':
          return this.otherUser.name + ' ' + this.$t('busy')
        case 'pending_unreachable':
          return this.otherUser.name + ' ' + this.$t('unreachable')
        case 'ringing_declined':
          return this.otherUser.name + ' ' + this.$t('busy')
        case 'ringing_finished':
        case 'ringing_missed':
          return this.$t('you_been_calling') + ' ' + this.otherUser.name + '-(ს)თან'
        case 'pending_disconnected':
        case 'pending_failed':
        case 'ringing_failed':
        case 'ringing_disconnected':
        case 'ongoing_disconnected':
        case 'ongoing_failed':
          return this.$t('you_called') + ' ' + this.otherUser.name + '-ს'

        default:
          return this.$t('call') + this.author.firstname.ka + '-(ს)თან'
      }
    }
  }
}
</script>

<style lang="scss">
.chat-item-default {
  width: 100%;

  span {
    background-color: #eee;
    border-radius: 0.9em;
    font-size: 0.8em;
    font-weight: normal;
    display: inline-block;
  }
  small {
    font-size: 0.65em;
  }
  &.me {
    text-align: right;
    span {
      background-color: #3c88ff;
      color: #fff;
    }
  }
}
</style>
<i18n>
{
  "ka": {
        "you_missed_call":"თქვენ გამოტოვეთ ზარი",
        "called_you": "დაგირეკათ თქვენ",
        "you_called": "თქვენ დაურეკეთ",
        "you_been_calling": "თქვენ რეკავდით",
        "call": "ზარი",
        "unreachable": "მიუწვდომელია",
        "busy": "დაკავებულია"
  },
  "en": {
        "you_missed_call":"You've missed a call",
        "called_you": "called ypu",
        "you_called": "you called",
        "you_been_calling": "you've been calling",
        "call": "Call",
        "unreachable": "Unreachable",
        "busy": "Busy"
  }
}
</i18n>
